import React, { useEffect, useMemo, useState } from "react";
import { assignRunCell, getClassSubjectsByWeek } from "./happyschoolApi";

const DAYS = ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];
const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/đ/gi, "d").toLowerCase();
const khoiOf = (name) => (String(name || "").match(/^\d+/) || [""])[0];

// Dialog admin ĐIỀN 1 Ô TRỐNG của giáo viên (mở bằng nhấn đúp ô trống ở TKB Giáo viên): chọn MÔN rồi chọn LỚP.
// Lớp đang trống ở giờ này hiện trước; lớp đã có tiết (GV khác) vẫn chọn được nhưng phải xác nhận ghi đè.
const HappySchoolCellAssignDialog = ({ schoolId, runId, weekId, target, grid, classes, subjects, teachers, onClose, onSaved, saveOverride }) => {
  const { teacherId, day, period } = target;
  const teacher = teachers.find((t) => t.id === teacherId) || {};
  const subjectById = useMemo(() => Object.fromEntries(subjects.map((s) => [s.id, s.name])), [subjects]);
  const teacherById = useMemo(() => Object.fromEntries(teachers.map((t) => [t.id, t.name])), [teachers]);
  const ownSubjects = (teacher.subjectIds || []).filter((sid) => subjectById[sid]);
  const [subjectId, setSubjectId] = useState(ownSubjects[0] || "");
  const [showAllSubj, setShowAllSubj] = useState(ownSubjects.length === 0);
  const [khoi, setKhoi] = useState("");
  const [q, setQ] = useState("");
  const [classId, setClassId] = useState("");
  const [reason, setReason] = useState("");
  const [needMap, setNeedMap] = useState(null); // { classId: { subjectId: periodsPerWeek } } — PCCM hiệu lực tuần này
  const [pccmMap, setPccmMap] = useState({}); // { classId: { subjectId: teacherId } } — GV được PCCM (hiệu lực tuần này)
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!schoolId || !weekId) return;
    getClassSubjectsByWeek(schoolId, weekId)
      .then((r) => {
        const eff = (r && r.effective) || {};
        const out = {};
        Object.entries(eff).forEach(([cid, m]) => { out[cid] = Object.fromEntries(Object.entries(m || {}).map(([sid, cfg]) => [sid, Number(cfg && cfg.periodsPerWeek) || 0])); });
        setNeedMap(out);
        const pc = {};
        Object.entries(eff).forEach(([cid, m]) => { pc[cid] = Object.fromEntries(Object.entries(m || {}).map(([sid, cfg]) => [sid, (cfg && cfg.assignedTeacherId) || ""])); });
        setPccmMap(pc);
      })
      .catch(() => setNeedMap({}));
  }, [schoolId, weekId]);

  const haveOf = useMemo(() => {
    const m = {}; // "classId|subjectId" -> số tiết đang có
    Object.entries(grid).forEach(([k, v]) => { if (Array.isArray(v) && v[0] != null) { const cid = k.split("|")[0]; m[`${cid}|${v[0]}`] = (m[`${cid}|${v[0]}`] || 0) + 1; } });
    return m;
  }, [grid]);

  const khois = useMemo(() => [...new Set(classes.map((c) => khoiOf(c.name)).filter(Boolean))].sort((a, b) => Number(b) - Number(a)), [classes]);

  const rows = useMemo(() => {
    const qn = norm(q);
    return classes
      .filter((c) => (!khoi || khoiOf(c.name) === khoi) && (!qn || norm(c.name).includes(qn)))
      .map((c) => {
        const cur = grid[`${c.id}|${day}|${period}`];
        const isHN = !!(cur && cur[0] === "HN"); // (23/10/2026) tiết học nghề — vẫn cho điền (ghi đè tiết nghề)
        const special = cur && cur[0] != null && !subjectById[cur[0]] && cur[0] !== "Nghỉ" && !isHN; // ô đặc biệt khác (Thi KS, Chào cờ...) — ô "Nghỉ"/"HN" vẫn điền được
        const occupied = !!(cur && cur[0] != null && cur[1]);
        const need = needMap && subjectId ? ((needMap[c.id] || {})[subjectId] || 0) : null;
        const have = subjectId ? (haveOf[`${c.id}|${subjectId}`] || 0) : 0;
        const pccmTid = subjectId ? ((pccmMap[c.id] || {})[subjectId] || "") : "";
        return { c, cur, special, isHN, occupied, need, have, lack: need === null ? 0 : need - have, pccmTid, mine: !!pccmTid && pccmTid === teacherId };
      })
      // Lớp mà GV này được PCCM đúng môn đang chọn lên đầu (đúng phân công, không phải dạy thay).
      .sort((a, b) => (a.special - b.special) || (b.mine - a.mine) || (a.occupied - b.occupied) || (b.lack > 0) - (a.lack > 0) || a.c.name.localeCompare(b.c.name, "vi", { numeric: true }));
  }, [classes, khoi, q, grid, day, period, subjectById, needMap, subjectId, haveOf, pccmMap, teacherId]);

  const picked = rows.find((r) => r.c.id === classId);

  const save = async () => {
    setErr("");
    if (!subjectId) { setErr("Chọn môn học."); return; }
    if (!classId) { setErr("Chọn lớp."); return; }
    if (picked && picked.isHN && !window.confirm(`Lớp ${picked.c.name} đang HỌC NGHỀ (HN) ở giờ này.\nThay tiết nghề bằng ${subjectById[subjectId]} — ${teacher.name}?`)) return;
    if (picked && picked.occupied && !window.confirm(`Lớp ${picked.c.name} đang có tiết ${subjectById[picked.cur[0]] || ""} (${teacherById[picked.cur[1]] || ""}) ở giờ này.\nGhi đè bằng ${subjectById[subjectId]} — ${teacher.name}?`)) return;
    setSaving(true);
    try {
      const payload = { teacherId, classId, subjectId, day, period, reason, overwrite: !!(picked && picked.occupied) };
      const r = saveOverride ? await saveOverride(payload) : await assignRunCell(schoolId, runId, payload);
      if (r && r.pending) window.alert(r.message || "Đã gửi yêu cầu sửa — chờ duyệt.");
      onSaved && onSaved(r);
    } catch (e) {
      setErr(e.message || "Lưu thất bại.");
    } finally {
      setSaving(false);
    }
  };

  const subjList = showAllSubj ? subjects.slice().sort((a, b) => a.name.localeCompare(b.name, "vi")) : ownSubjects.map((sid) => ({ id: sid, name: subjectById[sid] }));

  return (
    <div style={overlay} onClick={onClose}>
      <div style={box} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h3 style={{ margin: 0 }}>Điền ô trống: {teacher.name} — {DAYS[day]} tiết {period + 1}</h3>
          <button type="button" onClick={onClose} style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer" }}>✕</button>
        </div>
        <p style={{ margin: "6px 0 10px", color: "#6b7280", fontSize: 13 }}>Chọn môn và lớp để giáo viên dạy ở giờ này {saveOverride ? "(lưu thành ô xếp tay)" : "(ghi thẳng vào TKB đang xem, không ghi vào xếp tay)"}. Lớp có <b>PCCM ✓</b> là lớp giáo viên này được phân công đúng môn.</p>

        <div style={{ fontWeight: 700, fontSize: 13, color: "#6b7280", margin: "4px 0" }}>Môn học</div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6 }}>
          {subjList.map((s) => (
            <button key={s.id} type="button" onClick={() => { setSubjectId(s.id); setClassId(""); }} style={subjectId === s.id ? chipOn : chip}>{s.name}</button>
          ))}
          <button type="button" onClick={() => setShowAllSubj((v) => !v)} style={{ ...chip, borderStyle: "dashed" }}>{showAllSubj ? "Chỉ môn của GV" : "Môn khác..."}</button>
        </div>

        <div style={{ fontWeight: 700, fontSize: 13, color: "#6b7280", margin: "8px 0 4px" }}>Lớp</div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 6, alignItems: "center" }}>
          <button type="button" onClick={() => setKhoi("")} style={khoi === "" ? chipOn : chip}>Tất cả</button>
          {khois.map((k) => (<button key={k} type="button" onClick={() => setKhoi(k)} style={khoi === k ? chipOn : chip}>Khối {k}</button>))}
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm lớp..." style={{ padding: 5, border: "1px solid #d1d5db", borderRadius: 6, width: 110 }} />
        </div>
        <div style={{ maxHeight: 260, overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: 6 }}>
          {rows.length === 0 ? <p style={{ margin: 0, padding: 10, color: "#6b7280", fontSize: 13 }}>Không có lớp phù hợp.</p> : rows.map((r) => (
            <label key={r.c.id} style={{ display: "flex", gap: 8, alignItems: "center", padding: "5px 10px", borderBottom: "1px solid #f3f4f6", cursor: r.special ? "not-allowed" : "pointer", opacity: r.special ? 0.5 : 1, background: classId === r.c.id ? "#ecfdf5" : "#fff" }}>
              <input type="radio" name="assign-class" disabled={r.special} checked={classId === r.c.id} onChange={() => setClassId(r.c.id)} />
              <b style={{ minWidth: 52 }}>{r.c.name}</b>
              {r.special ? <span style={{ color: "#6b7280", fontSize: 12 }}>ô đặc biệt ({r.cur[0]})</span>
                : r.isHN ? <span style={tag("#a16207")}>đang học nghề (HN) — điền sẽ thay tiết nghề</span>
                : r.occupied ? <span style={tag("#b45309")}>đang có: {subjectById[r.cur[0]] || ""} — {teacherById[r.cur[1]] || ""}</span>
                : <span style={tag("#0f766e")}>{r.cur ? "trống GV" : "trống"}</span>}
              {subjectId && (
                <span style={{ fontSize: 11, padding: "1px 6px", borderRadius: 999, background: r.mine ? "#dcfce7" : "#f3f4f6", color: r.mine ? "#166534" : r.pccmTid ? "#9a3412" : "#6b7280", fontWeight: r.mine ? 700 : 400 }}>
                  PCCM: {r.pccmTid ? (teacherById[r.pccmTid] || r.pccmTid) : "chưa có"}{r.mine ? " ✓" : ""}
                </span>
              )}
              {subjectId && r.need !== null && (
                <span style={{ marginLeft: "auto", fontSize: 12, color: r.lack > 0 ? "#b45309" : "#6b7280", fontWeight: r.lack > 0 ? 700 : 400 }}>
                  {subjectById[subjectId]}: {r.have}/{r.need}{r.lack > 0 ? ` ⚠ thiếu ${r.lack}` : ""}
                </span>
              )}
            </label>
          ))}
        </div>

        <label style={{ display: "block", fontSize: 14, margin: "10px 0 0" }}>Lý do / ghi chú (không bắt buộc)
          <input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="VD: dạy bù, dạy thay..." style={{ width: "100%", boxSizing: "border-box", marginTop: 4, padding: 6, border: "1px solid #d1d5db", borderRadius: 6 }} />
        </label>
        {err && <p style={{ color: "#dc2626", margin: "8px 0 0" }}>{err}</p>}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
          <button type="button" onClick={onClose} disabled={saving} style={btnGhost}>Hủy</button>
          <button type="button" onClick={save} disabled={saving} style={btnPrimary}>{saving ? "Đang lưu..." : "Xác nhận điền tiết"}</button>
        </div>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
const box = { background: "#fff", borderRadius: 12, padding: 18, width: 640, maxWidth: "94vw", maxHeight: "92vh", overflowY: "auto", boxShadow: "0 20px 40px rgba(0,0,0,.2)" };
const chip = { padding: "4px 10px", border: "1px solid #d1d5db", borderRadius: 999, background: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 600, color: "#374151" };
const chipOn = { ...chip, background: "#0ea5a3", borderColor: "#0ea5a3", color: "#fff" };
const tag = (color) => ({ fontSize: 11, padding: "1px 6px", borderRadius: 999, border: `1px solid ${color}`, color });
const btnGhost = { padding: "8px 14px", border: "1px solid #d1d5db", background: "#fff", borderRadius: 6, cursor: "pointer", fontWeight: 600 };
const btnPrimary = { padding: "8px 16px", border: "none", background: "#0ea5a3", color: "#fff", borderRadius: 6, cursor: "pointer", fontWeight: 700 };

export default HappySchoolCellAssignDialog;
